import React, { useState, useEffect, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RadioButton } from "primereact/radiobutton";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { MultiSelect } from 'primereact/multiselect';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import { FloatLabel } from "primereact/floatlabel";
import Toast from '../../Shared/Toast/Toast';
import moment from 'moment';
import { useCatchResponse } from '../../../utils/useCatchResponse';


const AddEditFeeStructure = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [titleName, setTitleName] = useState("");
    const [titleNameErr, setTitleNameErr] = useState(false);
    const [titleNameErrText, setTitleNameErrText] = useState("");
    const [selectedQuota, setSelectedQuota] = useState([]);
    const [selectedClass, setSelectedClass] = useState([]);
    const [classNameErr, setClassNameErr] = useState(false);
    const [classNameErrText, setClassNameErrText] = useState("");
    const [feeData, setFeeData] = useState([]);
    const [feeCollectionMethod, setFeeCollectionMethod] = useState("one-time");
    const [startDateOneTime, setStartDateOneTime] = useState(null);
    const [endDateOneTime, setEndDateOneTime] = useState(null);
    const [startDateInstalment, setStartDateInstalment] = useState(null);
    const [endDateInstalment, setEndDateInstalment] = useState(null);
    const [fineTypeList, setFineTypeList] = useState([{ label: "Daily", value: 'Daily' }, { label: "Weekly", value: 'Weekly' }, { label: "Monthly", value: "Monthly" }]);
    const [quotaList, setQuotaList] = useState([]);
    const [feeList, setFeeList] = useState([]);
    const [classList, setClassList] = useState([]);
    const [fineDataOneTime, setFineDataOneTime] = useState([]);
    const [fineDataInstalment, setFineDataInstalment] = useState([]);
    const [installmentName, setInstallmentName] = useState('');
    const [installmentNameErr, setInstallmentNameErr] = useState(false);
    const [installmentNameErrText, setInstallmentNameErrText] = useState("");
    const [installmentNo, setInstallmentNo] = useState('');
    const [installmentMonth, setInstallmentMonth] = useState([]);
    const [installmentMonthErr, setInstallmentMonthErr] = useState(false);
    const [installmentMonthErrText, setInstallmentMonthErrText] = useState("");
    const [installmentMonthList, setInstallmentMonthList] = useState([]);
    const [selectedYear, setSelectedYear] = useState('');
    const titleNameRef = useRef(null);
    const [academicStartDate, setAcademicStartDate] = useState(null);
    const [academicEndDate, setAcademicEndDate] = useState(null);
    const [isAcademicYearApply, setIsAcademicYearApply] = useState(false);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        setTimeout(() => {
            titleNameRef.current?.focus();
        }, 100);
    }, []);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetClassList(loginData?._id, props?.masterData?.FinancialYear || props?.financialYearId);
        GetCasteList(loginData?._id);
        const months = Array.from({ length: 12 }, (_, i) => ({
            label: new Date(2000, i, 1).toLocaleString('en-US', { month: 'long' }),
            value: i + 1
        }));
        setInstallmentMonthList(months);
        let bodyList = [
            { id: '', FeeType: '', AdmissionType: 'All', isEdit: true }
        ];
        let fineList = [
            { id: '', FineType: '', FineAmount: '' }
        ];
        GetFeeList(loginData?._id).then(() => {
            if (props?.configId) {
                let feeListData = props?.masterData?.FeeData.length
                    ? props?.masterData?.FeeData.map(x => {
                        let dynamicData = x?.DynamicColumn?.reduce((acc, y) => {
                            acc[y.Key] = y.value;
                            return acc;
                        }, {});

                        return {
                            ...x,
                            ...dynamicData,
                        };
                    })
                    : [];
                setSelectedYear(props?.masterData?.FinancialYear);
                setTitleName(props?.masterData?.TitleName);
                setSelectedClass(props?.masterData?.ClassId ? props?.masterData?.ClassId.split(',') : []);
                setSelectedQuota(props?.masterData?.QuotaId ? props?.masterData?.QuotaId.split(',') : []);
                setFeeData(props?.masterData?.FeeData.length ? feeListData : bodyList);
                if (props?.masterData?.FeeCollectionMode === 'one-time') {
                    setFineDataOneTime(props?.masterData?.FineData.length ? props?.masterData?.FineData : fineList);
                } else {
                    setFineDataInstalment(props?.masterData?.FineData.length ? props?.masterData?.FineData : fineList);
                }
                if (props?.masterData?.FeeCollectionMode === 'one-time') {
                    setStartDateOneTime(props?.masterData?.StartDate ? new Date(props?.masterData?.StartDate) : null);
                    setEndDateOneTime(props?.masterData?.EndDate ? new Date(props?.masterData?.EndDate) : null);
                } else {
                    setStartDateInstalment(props?.masterData?.StartDate ? new Date(props?.masterData?.StartDate) : null);
                    setEndDateInstalment(props?.masterData?.EndDate ? new Date(props?.masterData?.EndDate) : null);
                }
                setFeeCollectionMethod(props?.masterData?.FeeCollectionMode || 'one-time');
                setInstallmentMonth(props?.masterData?.InstallmentMonth ? props?.masterData?.InstallmentMonth.split(',') : []);
                setInstallmentName(props?.masterData?.InstallmentName);
                setInstallmentNo(props?.masterData?.InstallmentNo);
            } else {
                setSelectedYear(props?.financialYearId);
                setFeeData(bodyList);
                if (props?.masterData?.FeeCollectionMode === 'one-time') {
                    setFineDataOneTime(fineList);
                } else {
                    setFineDataInstalment(fineList);

                }
            }
        });
        GetConfigurationData(loginData?._id);
    }, []);

    useEffect(() => {
        if (isAcademicYearApply) {
            const academicCalendar = props.academicYearList || [];

            if (!academicCalendar.length) {
                setAcademicStartDate(null);
                setAcademicEndDate(null);
                return;
            }

            const validRanges = academicCalendar.filter(
                item => item?.StartDate && item.EndDate && item?._id === selectedYear
            );

            if (!validRanges.length) {
                setAcademicStartDate(null);
                setAcademicEndDate(null);
                return;
            }

            const sortedCalendar = [...validRanges].sort(
                (a, b) =>
                    new Date(a?.StartDate) - new Date(b?.StartDate)
            );

            const start = new Date(sortedCalendar[0]?.StartDate);
            const end = new Date(sortedCalendar[0]?.EndDate);

            setAcademicStartDate(start);
            setAcademicEndDate(end);
        }
    }, [selectedYear, props.academicYearList, isAcademicYearApply]);

    const GetClassList = async (id, academicYearId) => {
        try {
            let data = {
                UserID: id,
                FinancialYearId: academicYearId
            }
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(
                        Array.from(
                            new Map(
                                res?.data?.filter(x => x?.Status === 'Active')?.map((x) => [
                                    x?.ClassId,
                                    {
                                        ...x,
                                        value: x?.ClassId,
                                        label: `${x?.ClassName}-${x?.MediumName}-${x?.Board}`
                                    }
                                ])
                            ).values()
                        )
                    );
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetCasteList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getCasteList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setQuotaList(res?.data?.map(x => ({
                        label: x?.CasteName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetFeeList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getFeeList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setFeeList((res?.data || []).filter(x => x?.Status === 'Active').map(x => ({
                        label: x?.FeeName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetConfigurationData = async (id) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.GetGeneralConfigurationDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    setIsAcademicYearApply(res?.data?.IsAcademicYearApply);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const toggleEdit = (rowIndex) => {
        const updatedFee = feeData?.map((item, idx) =>
            idx === rowIndex ? { ...item, isEdit: !item.isEdit } : item
        );
        setFeeData(updatedFee);
    };

    const deleteDataRow = (index, type) => {
        if (type === 'Fee') {
            const updatedFee = feeData?.filter((_, i) => i !== index);
            setFeeData(updatedFee);
        } else if (type === 'Fine') {
            if (feeCollectionMethod === "one-time") {
                const updatedFine = fineDataOneTime?.filter((_, i) => i !== index);
                setFineDataOneTime(updatedFine);
            } else {
                const updatedFine = fineDataInstalment?.filter((_, i) => i !== index);
                setFineDataInstalment(updatedFine);
            }
        }
    };

    const srNoBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const addDataValue = (type) => {
        if (type === 'Fee') {
            let values = [{ id: '', FeeType: '', AdmissionType: 'All', isEdit: true }];
            setFeeData([...feeData, ...values]);
        } else if (type === 'Fine') {
            if (feeCollectionMethod === "one-time") {
                let values = [{ id: '', FineType: '', FineAmount: '' }];
                setFineDataOneTime([...fineDataOneTime, ...values]);
            } else {
                let values = [{ id: '', FineType: '', FineAmount: '' }];
                setFineDataInstalment([...fineDataInstalment, ...values]);
            }
        }
    };

    const actionBodyTemplate = (rows, { rowIndex }) => {
        return (
            <React.Fragment>
                <div className="p-d-flex p-jc-end p-ai-center">
                    {rows.isEdit ? (
                        <Button icon="pi pi-check" className="e-sction-btn p-m-0 p-mt-3" onClick={(e) => toggleEdit(rowIndex)} />
                    ) : (
                        <Button icon="pi pi-pencil" className="e-sction-btn p-m-0 p-mt-3" onClick={(e) => toggleEdit(rowIndex)} />
                    )}
                    {rowIndex === feeData.length - 1 &&
                        <Button
                            icon="pi pi-plus"
                            className="e-sction-btn p-mr-0 p-my-0 p-ml-2"
                            onClick={() => addDataValue('Fee')}
                        />}
                    {(rowIndex !== 0 || feeData.length > 1) &&
                        <Button icon="pi pi-trash" className="e-sction-btn p-my-0 p-mt-3 p-ml-2"
                            onClick={() => deleteDataRow(rowIndex, 'Fee')}
                        />
                    }
                </div>
            </React.Fragment>
        );
    };

    const handleChange = (rowIndex, value, type) => {
        setFeeData(prev => {
            const updated = prev.map((item, idx) => {
                if (idx !== rowIndex) return item;
                const newItem = { ...item };
                if (type === 'FeeType') {
                    newItem.FeeType = value;
                    newItem.FeeTypeName = feeList?.find(q => q?.value === value)?.label || '';
                } else if (type === 'AdmissionType') {
                    newItem.AdmissionType = value;
                } else {
                    newItem[type] = (value || '').toString().replace(/[^0-9]/g, '');
                }
                return newItem;
            });
            return updated;
        });
    };

    const feeTypeBodyTemplate = (rows, { rowIndex }) => {
        const usedFeeTypes = feeData
            .filter((_, idx) => idx !== rowIndex)
            .map(f => f.FeeType)
            .filter(Boolean);
        const availableOptions = feeList.filter(f => !usedFeeTypes.includes(f.value));

        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center custom-inputs'>
                    {rows?.isEdit ? (
                        <Dropdown
                            className="p-w-100 p-mt-1"
                            name='feeType'
                            inputId='feeType'
                            value={rows?.FeeType}
                            options={availableOptions}
                            onChange={(e) => handleChange(rowIndex, e.value, 'FeeType')}
                            placeholder="Select Fee Type"
                            filter
                            showClear
                        />
                    ) : <div>{rows?.FeeTypeName} </div>}
                </div>
            </React.Fragment>
        );
    };

    const casteBodyTemplate = (rowData, type, { rowIndex }) => {
        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center'>
                    {rowData?.isEdit ? (
                        <InputText
                            value={rowData?.[type]}
                            maxLength={4}
                            onChange={(e) => handleChange(rowIndex, e.target.value, type)}
                            style={{ width: "60px", textAlign: "center" }}
                        />
                    ) : <div>{rowData?.[type]} </div>}
                </div>
            </React.Fragment>
        );
    };

    const handleFineChange = (rowIndex, value, type) => {
        if (feeCollectionMethod === "one-time") {
            const updatedFineValues = [...fineDataOneTime];
            let textValue = value;
            if (type === 'FineAmount') {
                textValue = value.replace(/[^0-9]/g, '');
            }
            updatedFineValues[rowIndex][type] = textValue;
            setFineDataOneTime(updatedFineValues);
        } else {
            const updatedFineValues = [...fineDataInstalment];
            let textValue = value;
            if (type === 'FineAmount') {
                textValue = value.replace(/[^0-9]/g, '');
            }
            updatedFineValues[rowIndex][type] = textValue;
            setFineDataInstalment(updatedFineValues);
        }
    };

    const onCancel = () => {
        props.onCancel();
        setTitleName('');
        setSelectedClass([]);
        setSelectedQuota([]);
        setFeeData([]);
        setFineDataOneTime([]);
        setFineDataInstalment([]);
        setStartDateOneTime(null);
        setEndDateOneTime(null);
        setStartDateInstalment(null);
        setEndDateInstalment(null);
    }

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(titleName)) {
            formIsValid = false;
            setTitleNameErr(true);
            setTitleNameErrText("Title Name is required");
        } else {
            setTitleNameErr(false);
            setTitleNameErrText("");
        }
        if (selectedClass.length === 0) {
            formIsValid = false;
            setClassNameErr(true);
            setClassNameErrText("Select atleast one class");
        } else {
            setClassNameErr(false);
            setClassNameErrText("");
        }
        if (feeCollectionMethod === 'installments') {
            if (CommonConfig.isEmpty(installmentName)) {
                formIsValid = false;
                setInstallmentNameErr(true);
                setInstallmentNameErrText("Installemnt Name is required");
            } else {
                setInstallmentNameErr(false);
                setInstallmentNameErrText("");
            }
            if (installmentMonth.length === 0) {
                formIsValid = false;
                setInstallmentMonthErr(true);
                setInstallmentMonthErrText("Select atleast one month");
            } else {
                setInstallmentMonthErr(false);
                setInstallmentMonthErrText("");
            }
        }
        return formIsValid;
    };

    const AddUpdateFeeStructure = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                var feeListData = [];

                if (feeData) {
                    feeListData = feeData.map((x, idx) => {
                        return {
                            ...x,
                            DynamicColumn: Object.keys(x).filter(z => z !== 'AdmissionType' && z !== 'FeeType' && z !== 'FeeTypeName' && z !== 'isEdit' && z !== '_id').map(y => ({
                                Key: y,
                                value: x[y]
                            })),
                        }
                    })
                }
                let data = {
                    id: props?.configId,
                    FinancialYear: selectedYear,
                    TitleName: titleName.trim().replace(/\s+/g, ' '),
                    ClassId: selectedClass.length > 1 ? selectedClass.join(',') : selectedClass[0],
                    QuotaId: selectedQuota.length > 1 ? selectedQuota.join(',') : selectedQuota[0],
                    FeeData: feeListData,
                    FeeCollectionMode: feeCollectionMethod,
                    StartDate: feeCollectionMethod === "one-time" ? (startDateOneTime ? moment(startDateOneTime).format("YYYY-MM-DD[T]HH:mm") + "+05:30" : null) : (startDateInstalment ? moment(startDateInstalment).format("YYYY-MM-DD[T]HH:mm") + "+05:30" : null),
                    EndDate: feeCollectionMethod === "one-time" ? (endDateOneTime ? moment(endDateOneTime).format("YYYY-MM-DD[T]HH:mm") + "+05:30" : null) : (endDateInstalment ? moment(endDateInstalment).format("YYYY-MM-DD[T]HH:mm") + "+05:30" : null),
                    InstallmentName: feeCollectionMethod === "one-time" ? '' : installmentName,
                    InstallmentNo: feeCollectionMethod === "one-time" ? '' : installmentNo,
                    InstallmentMonth: feeCollectionMethod === "one-time" ? '' : installmentMonth.length > 1 ? installmentMonth.join(',') : installmentMonth[0],
                    FineData: feeCollectionMethod === "one-time" ? fineDataOneTime : fineDataInstalment,
                    CreatedBy: securityUserID,
                };
                await api
                    .post(APIConstant.path.AddUpdateFeeStructure, data)
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                            onCancel();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Toast.error({ message: err });
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    return (
        <div>
            <div style={{ maxHeight: 'calc(100vh - 260px)', overflow: 'auto' }}>
                <div className="p-grid">
                    <div className="p-col-12 p-md-4 custom-inputs">
                        <label htmlFor="titleName">Title Name<span style={{ color: "red" }}>*</span></label>
                        <FloatLabel>
                            <InputText
                                ref={titleNameRef}
                                className='p-mt-1 p-w-100'
                                id="titleName"
                                maxLength={20}
                                value={titleName}
                                onChange={(e) => setTitleName(e.target.value)}
                                style={{
                                    fontFamily: "Noto Sans, Arial, sans-serif"
                                }}
                            />
                        </FloatLabel>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {titleNameErr ? titleNameErrText : null}
                        </span>
                    </div>
                    <div className="p-col-12 p-md-4 custom-inputs">
                        <div className="e-add-fee-structure">
                            <p className="p-m-0">Class<span style={{ color: "red" }}>*</span></p>
                            <MultiSelect
                                id="className"
                                value={selectedClass} options={classList}
                                onChange={(e) => setSelectedClass(e.value)}
                                placeholder="Select Class"
                                display="chip"
                                className='p-w-100 p-mt-1'
                                filter />
                            <span className="error-msg" style={{ color: 'red' }}>
                                {classNameErr ? classNameErrText : null}
                            </span>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4 p-pt-2">
                        <div className="custom-inputs">
                            <label htmlFor="selectedYear">Academic Years</label>
                            <Dropdown
                                id="selectedYear"
                                value={selectedYear}
                                options={props?.academicYearList}
                                onChange={(e) => setSelectedYear(e.value)}
                                placeholder="Select Academic Year"
                                display="chip"
                                className='p-w-100 p-mt-1'
                                filter
                                optionLabel="label"
                                optionValue="_id"
                                showClear
                            />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4 custom-inputs">
                        <div className="e-add-fee-structure">
                            <label htmlFor="className">Do you want to add Quota?</label>
                            <div className="p-d-flex p-ai-center p-jc-between">
                                <MultiSelect
                                    id="quota"
                                    value={selectedQuota} options={quotaList}
                                    onChange={(e) => setSelectedQuota(e.value)}
                                    placeholder="Select Quota"
                                    display="chip"
                                    className='p-w-100 p-mt-1'
                                    filter />
                            </div>
                        </div>
                    </div>
                </div>

                <DataTable value={feeData} responsiveLayout="scroll" className="e-add-fee-structure-table"
                >
                    <Column body={srNoBodyTemplateSrNo} header="Sr No." />
                    <Column body={feeTypeBodyTemplate} header="Fee Type" />
                    <Column field="AdmissionType" header="Admission Type" body={(rowData, { rowIndex }) => (
                        rowData?.isEdit ? (
                            <Dropdown
                                className="p-w-100"
                                value={rowData?.AdmissionType}
                                options={[
                                    { label: 'All', value: 'All' },
                                    { label: 'New', value: 'New' },
                                    { label: 'Existing', value: 'Existing' },
                                ]}
                                onChange={(e) => handleChange(rowIndex, e.value, 'AdmissionType')}
                                placeholder="Select Type"
                            />
                        ) : <div>{rowData?.AdmissionType}</div>
                    )} />
                    {selectedQuota?.map((quota) => (
                        <Column key={quota} body={(rowData, rowIndex) => casteBodyTemplate(rowData, (quotaList?.find(q => q.value === quota)?.label), rowIndex)} header={quotaList?.find(q => q.value === quota)?.label} />
                    ))}
                    <Column header="Action" body={actionBodyTemplate} headerStyle={{ display: 'flex', justifyContent: 'end', }} />
                </DataTable>

                <div className="form-header p-mt-2">
                    <div>
                        <span>Fee Collection Method*</span>
                        <div className="radio-group p-mt-2 p-ml-2">
                            <RadioButton
                                inputId="one-time"
                                name="feeCollection"
                                value="one-time"
                                onChange={(e) => setFeeCollectionMethod(e.value)}
                                checked={feeCollectionMethod === "one-time"}
                            />
                            <label htmlFor="one-time" className="radio-label">One time</label>
                            <div className="p-ml-5">
                                <RadioButton
                                    inputId="installments"
                                    name="feeCollection"
                                    value="installments"
                                    onChange={(e) => setFeeCollectionMethod(e.value)}
                                    checked={feeCollectionMethod === "installments"}
                                />
                                <label htmlFor="installments" className="radio-label p-ml-2">Installments</label>
                            </div>
                        </div>
                    </div>
                </div>
                {feeCollectionMethod === "one-time" ? (
                    <>
                        <div className="p-grid">
                            <div className="p-col-4 p-md-4">
                                <label htmlFor="startDateTime">Start Date & Time</label>
                                <div>
                                    <Calendar
                                        className='p-w-100 p-mt-0'
                                        id="startDateTime"
                                        onChange={(e) => setStartDateOneTime(e.value)}
                                        placeholder="DD/MM/YYYY - HH:MM"
                                        showTime
                                        value={startDateOneTime}
                                        minDate={academicStartDate}
                                        maxDate={academicEndDate}
                                        hideOnDateTimeSelect
                                        hourFormat="12"
                                        dateFormat="dd/mm/yy"
                                        style={{ height: '42px' }}
                                    />
                                </div>
                            </div>
                            <div className="p-col-4 p-md-4">
                                <label htmlFor="endDateTime">End Date & Time</label>
                                <div>
                                    <Calendar
                                        className='p-w-100 p-mt-0'
                                        id="endDateTime"
                                        onChange={(e) => setEndDateOneTime(e.value)}
                                        placeholder="DD/MM/YYYY - HH:MM"
                                        showTime
                                        hideOnDateTimeSelect
                                        value={endDateOneTime}
                                        minDate={startDateOneTime || academicStartDate}
                                        maxDate={academicEndDate}
                                        hourFormat="12"
                                        dateFormat="dd/mm/yy"
                                        style={{ height: '42px' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </>) : (
                    <>
                        <div className="p-grid">
                            <div className="p-col-4 p-md-4">
                                <label htmlFor="installmentName">Installment Name<span style={{ color: "red" }}>*</span></label>
                                <FloatLabel>
                                    <InputText
                                        className='p-mt-1 p-w-100'
                                        id="installmentName"
                                        maxLength={20}
                                        value={installmentName}
                                        onChange={(e) => setInstallmentName(e.target.value)}
                                        style={{
                                            fontFamily: "Noto Sans, Arial, sans-serif"
                                        }}
                                    />
                                </FloatLabel>
                                <span className="error-msg" style={{ color: 'red' }}>
                                    {installmentNameErr ? installmentNameErrText : null}
                                </span>
                            </div>
                            <div className="p-col-4 p-md-4">
                                <label htmlFor="installmentNo">Installment No.</label>
                                <FloatLabel>
                                    <InputText
                                        className='p-mt-1 p-w-100'
                                        id="installmentNo"
                                        maxLength={3}
                                        value={installmentNo}
                                        onChange={(e) => setInstallmentNo(e.target.value)}
                                    />
                                </FloatLabel>
                            </div>
                            <div className="p-col-4 p-md-4">
                                <label htmlFor="installmentMonth">Select Months<span style={{ color: "red" }}>*</span></label>
                                <MultiSelect
                                    id="installmentMonth"
                                    value={installmentMonth}
                                    options={installmentMonthList}
                                    onChange={(e) => setInstallmentMonth(e.value)}
                                    placeholder="Select"
                                    className='p-w-100 p-mt-1'
                                    filter
                                />
                                <span className="error-msg" style={{ color: 'red' }}>
                                    {installmentMonthErr ? installmentMonthErrText : null}
                                </span>
                            </div>
                            <div className="p-col-4 p-md-4">
                                <label htmlFor="startDateTime">Start Date & Time</label>
                                <div>
                                    <Calendar
                                        className='p-w-100 p-mt-0'
                                        id="startDateTime"
                                        onChange={(e) => setStartDateInstalment(e.value)}
                                        placeholder="DD/MM/YYYY" showTime
                                        value={startDateInstalment}
                                        minDate={academicStartDate}
                                        maxDate={academicEndDate}
                                        hideOnDateTimeSelect
                                        hourFormat="12"
                                        dateFormat="dd/mm/yy"
                                    />
                                </div>
                            </div>
                            <div className="p-col-4 p-md-4">
                                <label htmlFor="endDateTime">End Date & Time</label>
                                <div>
                                    <Calendar
                                        className='p-w-100 p-mt-0'
                                        id="endDateTime"
                                        onChange={(e) => setEndDateInstalment(e.value)}
                                        placeholder="DD/MM/YYYY - HH:MM"
                                        showTime
                                        hideOnDateTimeSelect
                                        value={endDateInstalment}
                                        minDate={startDateInstalment || academicStartDate}
                                        maxDate={academicEndDate}
                                        hourFormat="12"
                                        dateFormat="dd/mm/yy"
                                    />
                                </div>
                            </div>
                            <div className="p-col-4 p-md-12">
                                <div className="p-d-flex p-ai-center p-mt-3 p-pt-1">
                                    <div className="fee-collection-container">
                                        <span>Do you want to add Fine?</span>
                                    </div>
                                    <Button icon="pi pi-plus" className="e-border-btn p-mr-0 p-my-0 p-ml-2" onClick={e => addDataValue('Fine')} />
                                </div>
                            </div>
                        </div>
                    </>
                )}
                <div>
                    {(feeCollectionMethod === "one-time" ? fineDataOneTime : fineDataInstalment).map((data, idx) => (
                        <div key={idx} className="p-mt-1">
                            <div className="p-d-flex p-ai-center p-jc-between p-w-100 p-px-3">
                                <p className="text-15 p-text-bold p-text-capitalize p-m-0">Add more details</p>
                                {(idx !== 0 || (feeCollectionMethod === "one-time" ? fineDataOneTime : fineDataInstalment).length > 1) &&
                                    <div className="">
                                        <Button icon="pi pi-trash" className="p-d-flex p-ai-center p-jc-center p-m-0 p-button-rounded p-button-danger" onClick={() => deleteDataRow(idx, 'Fine')} />
                                    </div>
                                }
                            </div>
                            <div className="p-grid p-ai-center p-p-1">
                                <div className="p-col-6">
                                    <label htmlFor="fineType">Fine Type</label>
                                    <Dropdown
                                        id="fineType"
                                        value={data?.FineType}
                                        options={fineTypeList}
                                        onChange={(e) => handleFineChange(idx, e.value, 'FineType')}
                                        placeholder="Daily/Weekly/Monthly"
                                        className='p-w-100'
                                        filter
                                        showClear
                                    />
                                </div>
                                <div className="p-col-6">
                                    <label htmlFor="fineAmount">Fine Amount</label>
                                    <InputText
                                        id="fineAmount"
                                        placeholder="Enter Fine Amount"
                                        maxLength={4}
                                        value={data?.FineAmount}
                                        onChange={(e) => handleFineChange(idx, e.target.value, 'FineAmount')}
                                        className='p-w-100'
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="dialog-footer p-d-flex p-ai-center p-jc-end p-pb-5">
                <Button className='p-m-0 btn-text-action-secondary p-m-1' label="Cancel" onClick={(e) => onCancel()} />
                <Button label="Save" className="p-m-0 btn-text-action-primary" onClick={(e) => AddUpdateFeeStructure()} />
            </div>
        </div>
    );
};

export default AddEditFeeStructure;
